/* eslint-disable no-restricted-globals */
import { apimCall } from '../../helpers/api';
import {
  GettingTemplateFoldersError,
  SuccessfulGroupCreation,
  CreateGroupError,
  GetGroupsDropdownError,
  AddGroupError,
  GetGroupDetailsError,
  SuccessfulGroupUpdate,
  SavingGroupError,
  SuccessfulGroupDeletion,
  DeletingGroupError
} from '../../helpers/jargon';
import { formatString } from '../../helpers/utility';
import { showBanner } from '../../helpers/MessageUtility';
import { RootState } from '../../gf-types';
import { GroupDetails } from '../../usersgroups/usergroup-types';
import { GoFormzServices } from '../../AppSettings';
import { NavigateFunction } from 'react-router-dom';

export const FETCH_GROUP_REQUEST = 'FETCH_GROUP_REQUEST';
export const FETCH_GROUP_FAILURE = 'FETCH_GROUP_FAILURE';
export const FETCH_GROUP_SUCCESS = 'FETCH_GROUP_SUCCESS';

export const ADD_GROUP_REQUEST = 'ADD_GROUP_REQUEST';
export const ADD_GROUP_SUCCESS = 'ADD_GROUP_SUCCESS';
export const ADD_GROUP_FAILURE = 'ADD_GROUP_FAILURE';

export const CREATE_GROUP_REQUEST = 'CREATE_GROUP_REQUEST';
export const CREATE_GROUP_SUCCESS = 'CREATE_GROUP_SUCCESS';
export const CREATE_GROUP_FAILURE = 'CREATE_GROUP_FAILURE';

export const FETCH_GROUP_DETAILS_REQUEST = 'FETCH_GROUP_DETAILS_REQUEST';
export const FETCH_GROUP_DETAILS_SUCCESS = 'FETCH_GROUP_DETAILS_SUCCESS';
export const FETCH_GROUP_DETAILS_FAILURE = 'FETCH_GROUP_DETAILS_FAILURE';

export const SAVE_GROUP_REQUEST = 'SAVE_GROUP_REQUEST';
export const SAVE_GROUP_SUCCESS = 'SAVE_GROUP_SUCCESS';
export const SAVE_GROUP_FAILURE = 'SAVE_GROUP_FAILURE';

export const UPDATE_GROUP_NAME = 'UPDATE_GROUP_NAME';

export const DELETE_GROUP_REQUEST = 'DELETE_GROUP_REQUEST';
export const DELETE_GROUP_SUCCESS = 'DELETE_GROUP_SUCCESS';
export const DELETE_GROUP_FAILURE = 'DELETE_GROUP_FAILURE';

export const UPDATE_BINARY_PERMISSION = 'UPDATE_BINARY_PERMISSION';
export const UPDATE_FOLDER_PERMISSION = 'UPDATE_FOLDER_PERMISSION';
export const UPDATE_ALLFORM_PERMISSIONS = 'UPDATE_ALLFORM_PERMISSIONS';
export const UPDATE_ALL_BINARY_PERMISSION = 'UPDATE_ALL_BINARY_PERMISSION';

export const FETCH_TEMPLATE_FOLDER_SUCCESS = 'FETCH_TEMPLATE_FOLDER_SUCCESS';
export const FETCH_TEMPLATE_FOLDER_FAILURE = 'FETCH_TEMPLATE_FOLDER_FAILURE';

export const CLEAR_ERROR = 'CLEAR_ERROR';

function handleFriendlyErrors(error) {
  if (error.status === '400' || 400) {
    if (error.responseText) {
      const jsonResponse = JSON.parse(error.responseText);
      if (jsonResponse) {
        return jsonResponse.error;
      }
    }
    if (error.response.data.error) {
      return error.response.data.error;
    }
  }
  return '';
}

export function fetchTemplateFolderSuccess(folders) {
  return {
    type: FETCH_TEMPLATE_FOLDER_SUCCESS,
    payload: folders
  };
}

export function fetchTemplateFolderFailure(error) {
  return {
    type: FETCH_TEMPLATE_FOLDER_FAILURE,
    payload: {
      error: handleFriendlyErrors(error) !== '' ? handleFriendlyErrors(error) : GettingTemplateFoldersError,
      isFetching: false
    }
  };
}

export function createGroupRequest() {
  return {
    type: CREATE_GROUP_REQUEST,
    meta: {
      remote: true
    },
    payload: {
      isFetching: true
    }
  };
}

export const createGroup = (navigate: NavigateFunction) => async (dispatch, getState: () => RootState) => {
  dispatch(createGroupRequest());

  const groupState = getState().groupList;
  const newFolders = groupState.folders.map((folder) => {
    return {
      id: folder.id,
      permissions: folder.permissions
    };
  });
  const newGroup = {
    name: groupState.name,
    parentId: groupState.parentId,
    binaryPermissions: groupState.binaryPermissions,
    folderPermissions: newFolders
  };
  try {
    const response = await apimCall(GoFormzServices.AccountService, '/groups/', 'POST', newGroup);
    dispatch(createGroupSuccess(response.data));
    if (response?.data?.id) {
      navigate(`/manage/groups?groupId=${response.data.id}`);
      showBanner(formatString(SuccessfulGroupCreation, newGroup.name));
    }
  } catch (error) {
    dispatch(createGroupFailure(error));
  }
};

export function createGroupSuccess(payload) {
  return { type: CREATE_GROUP_SUCCESS, payload };
}

export function createGroupFailure(error) {
  return {
    type: CREATE_GROUP_FAILURE,
    payload: {
      error: handleFriendlyErrors(error) !== '' ? handleFriendlyErrors(error) : CreateGroupError,
      isFetching: false
    }
  };
}

export function fetchGroupRequest(groupId = undefined) {
  return {
    type: FETCH_GROUP_REQUEST,
    meta: {
      remote: true
    },
    payload: {
      isFetching: true,
      id: groupId,
      error: ''
    }
  };
}

export const fetchGroups =
  (groupId, allGroups = false) =>
  (dispatch) => {
    const requestBody = {
      groupId,
      userId: '',
      allGroups
    };
    dispatch(fetchGroupRequest(groupId));
    return apimCall(GoFormzServices.AccountService, `/groups/list/`, 'POST', requestBody)
      .then((response) => dispatch(fetchGroupSuccess(response.data, groupId)))
      .catch((error) => dispatch(fetchGroupFailure(error)));
  };

export function fetchGroupSuccess(data, groupId = undefined) {
  return {
    type: FETCH_GROUP_SUCCESS,
    payload: {
      data,
      id: groupId
    }
  };
}

export function fetchGroupFailure(error) {
  return {
    type: FETCH_GROUP_FAILURE,
    payload: {
      error: handleFriendlyErrors(error) !== '' ? handleFriendlyErrors(error) : GetGroupsDropdownError,
      isFetching: false
    }
  };
}

export function addGroupRequest(pId = undefined) {
  return {
    type: ADD_GROUP_REQUEST,
    meta: {
      remote: true
    },
    payload: {
      parentId: pId,
      isFetching: true
    } as GroupDetails
  };
}

export const addGroup =
  (parentId = undefined) =>
  (dispatch) => {
    dispatch(addGroupRequest(parentId));
    if (parentId !== undefined) {
      return apimCall(GoFormzServices.AccountService, `/groups/${parentId}`)
        .then((response) => dispatch(addGroupSuccess(response.data)))
        .catch((error) => dispatch(addGroupFailure(error)));
    }
    return apimCall(GoFormzServices.AccountService, '/folders/list')
      .then((response) => dispatch(fetchTemplateFolderSuccess(response.data)))
      .catch((error) => dispatch(fetchTemplateFolderFailure(error)));
  };

export function addGroupSuccess(data) {
  return {
    type: ADD_GROUP_SUCCESS,
    payload: data
  };
}

export function addGroupFailure(error) {
  return {
    type: ADD_GROUP_FAILURE,
    payload: {
      error: handleFriendlyErrors(error) !== '' ? handleFriendlyErrors(error) : AddGroupError,
      isFetching: false
    }
  };
}

export function fetchGroupDetailRequest(groupId) {
  return {
    type: FETCH_GROUP_DETAILS_REQUEST,
    meta: {
      remote: true
    },
    payload: {
      groupId,
      isFetching: true
    }
  };
}

export const fetchGroupDetailAsync = (groupId) => async (dispatch) => {
  dispatch(fetchGroupDetailRequest(groupId));
  try {
    const response = await apimCall(GoFormzServices.AccountService, `/groups/${groupId}`);
    if (response.data) {
      dispatch(fetchGroupDetailSuccess(response.data));
    }
  } catch (error) {
    console.error(error);
    dispatch(fetchGroupDetailFailure(error));
  }
};

export function fetchGroupDetailSuccess(payload) {
  return { type: FETCH_GROUP_DETAILS_SUCCESS, payload };
}

export function fetchGroupDetailFailure(error) {
  return {
    type: FETCH_GROUP_DETAILS_FAILURE,
    payload: {
      error: handleFriendlyErrors(error) !== '' ? handleFriendlyErrors(error) : GetGroupDetailsError,
      isFetching: false
    }
  };
}

export function updateBinaryPermission(permission) {
  return {
    type: UPDATE_BINARY_PERMISSION,
    payload: {
      permission
    }
  };
}

export function updateAllBinaryPermission(flag) {
  return {
    type: UPDATE_ALL_BINARY_PERMISSION,
    payload: {
      allBinaryPermission: flag
    }
  };
}

export function updateAllFormPermissions(flag) {
  return {
    type: UPDATE_ALLFORM_PERMISSIONS,
    payload: {
      allFormPermissions: flag
    }
  };
}

export function updateFolderPermission(id, permission) {
  return {
    type: UPDATE_FOLDER_PERMISSION,
    payload: {
      id,
      permission
    }
  };
}

export function updateGroupName(name) {
  return {
    type: UPDATE_GROUP_NAME,
    payload: {
      name
    }
  };
}

export function saveGroupRequest() {
  return {
    type: SAVE_GROUP_REQUEST,
    meta: {
      remote: true
    },
    payload: {
      isFetching: true,
      error: ''
    }
  };
}

export const saveGroup = () => (dispatch, getState: () => RootState) => {
  dispatch(saveGroupRequest());

  const groupState = getState().groupList;
  const folders = groupState.folders.map((folder) => {
    return {
      id: folder.id,
      permissions: folder.permissions
    };
  });
  const group = {
    Name: groupState.name,
    binaryPermissions: groupState.binaryPermissions,
    folderPermissions: folders
  };
  const groupId = groupState.id;

  return apimCall(GoFormzServices.AccountService, `/groups/${groupId}/update`, 'POST', group)
    .then(() => {
      dispatch(saveGroupSuccess());
      showBanner(formatString(SuccessfulGroupUpdate, group.Name));
    })
    .catch((error) => dispatch(saveGroupFailure(error)));
};

export function saveGroupSuccess() {
  return {
    type: SAVE_GROUP_SUCCESS,
    payload: {
      isFetching: false,
      error: ''
    }
  };
}

export function saveGroupFailure(error) {
  return {
    type: SAVE_GROUP_FAILURE,
    payload: {
      error: handleFriendlyErrors(error) !== '' ? handleFriendlyErrors(error) : SavingGroupError,
      isFetching: false
    }
  };
}

export function deleteGroupRequest(id) {
  return {
    type: DELETE_GROUP_REQUEST,
    meta: {
      remote: true
    },
    payload: {
      id,
      isFetching: true
    }
  };
}

export const deleteGroup = (groupId: string, navigate: NavigateFunction) => (dispatch, getState: () => RootState) => {
  dispatch(deleteGroupRequest(groupId));
  return apimCall(GoFormzServices.AccountService, `/groups/${groupId}/delete`, 'POST')
    .then(() => {
      dispatch(deleteGroupSuccess());
      navigate('/manage/groups');
      showBanner(formatString(SuccessfulGroupDeletion, getState().groupList.name));
    })
    .catch((error) => dispatch(deleteGroupFailure(error)));
};

export function deleteGroupSuccess() {
  return {
    type: DELETE_GROUP_SUCCESS,
    payload: {
      isFetching: false,
      error: ''
    }
  };
}

export function deleteGroupFailure(error) {
  return {
    type: DELETE_GROUP_FAILURE,
    payload: {
      error: handleFriendlyErrors(error) !== '' ? handleFriendlyErrors(error) : DeletingGroupError,
      isFetching: false
    }
  };
}

export function clearError() {
  return {
    type: CLEAR_ERROR,
    payload: {
      error: null
    }
  };
}
